import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';
import { theme } from 'theme/App.theme';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  root: {
    maxWidth: '20rem',
    maxHeight: '3.5625rem',
    zIndex: 10,
    marginBottom: '0.9375rem',
    [theme.breakpoints.up('viewportMobileMid')]: {
      maxWidth: 'none',
    },
    ...(theme.themeName === 'honda' && {
      boxShadow: 'none',
      background: 'transparent',
      marginBottom: '1.875rem',
      maxWidth: 'unset',
    }),
  },
  tabIndicator: {
    zIndex: 3,
    backgroundColor: colors.acura_red,
    ...(theme.themeName === 'honda' && {
      display: 'none',
    }),
  },
  tab: {
    background: colors.off_white,
    border: 0,
    color: colors.light_grey_4,
    lineHeight: '1.25rem',
    zIndex: 1,
    opacity: 1,
    padding: '1.25rem 0 1.0625rem',
    '&.Mui-selected': {
      color: colors.light_grey_4,
      background: colors.white,
      boxShadow: '0 0.1875rem 0.625rem 0.0625rem rgb(0 0 0 / 21%)',
      zIndex: 2,
    },
    '&.Mui-focusVisible': {
      outline: '0.125rem solid',
      outlineOffset: -2,
      outlineColor: colors.black,
    },
    ...(theme.themeName === 'honda' && {
      background: colors.white,
      border: `0.0625rem solid #c4c4c4`,
      borderRadius: '0.25rem',
      width: 'calc(50% - 0.3125rem)',
      height: '2.625rem',
      margin: '0 0.3125rem 0 0',
      color: colors.dark_blue_1,
      '&:nth-child(even)': {
        margin: '0 0 0 0.3125rem',
      },
      '&.Mui-selected': {
        boxShadow: 'none',
        border: 'none',
        backgroundColor: colors.honda_blue,
        color: colors.white,
      },
    }),
  },
});
